import { FC } from "react";
import { CircularProgress, Box, styled } from "@mui/material";

const StyledLoading = styled("div")({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative"
});

const LogoWrapper = styled(Box)({
  position: "relative",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 160,
  height: 160,
});

const CircularProgressWrapper = styled(CircularProgress)({
  position: "absolute",
});

const Loading: FC = () => {
  return (
    <StyledLoading>
      <LogoWrapper>
        <img
          src="/assets/images/conference/FMI/logo_fmi-removebg-preview.png"
          alt=""
          style={{ width: '120px', height: '80px' }}
        />
        <CircularProgressWrapper size={100} />
      </LogoWrapper>
    </StyledLoading>
  );
};

export default Loading;